module.exports = __webpack_public_path__ + "img/cope.81fd9be0.jpg";